import { DASHBOARD_PANEL_HEADER_CLASS } from "../_utils/dashboardPanelStyles";

type DashboardTasksPanelHeaderProps = {
  canViewTasks?: boolean;
  showChangeRequestsSection?: boolean;
  isEmpty?: boolean;
};

export default function DashboardTasksPanelHeader({
  canViewTasks = true,
  showChangeRequestsSection = false,
  isEmpty = false
}: DashboardTasksPanelHeaderProps) {
  let description: string | null = null;

  if (canViewTasks && !isEmpty) {
    description = `Review your assigned tasks${showChangeRequestsSection ? " and pending change requests" : ""} below.`;
  } else if (showChangeRequestsSection) {
    description = "Review pending change requests below.";
  }

  return (
    <div className={DASHBOARD_PANEL_HEADER_CLASS}>
      <div className="min-w-0">
        <h2 className="!m-0 text-title-medium-bold text-sys-brand-on-surface">To Do</h2>
        {description ? (
          <p className="mt-1 text-body-medium text-sys-brand-on-surface-variant" data-testid="tasks-scope-description">
            {description}
          </p>
        ) : null}
      </div>
    </div>
  );
}
